<template>
  <!-- 修改用户名称 -->
  <el-dialog
    title="修改用户名称"
    :visible.sync="visible"
    center
    :close-on-click-modal="false"
    width="554px"
    :before-close="handleClose">
    <el-alert
      class="alert"
      title
      type="info"
      :closable="false"
      show-icon
    >
      名称长度1-16位字符，只可以输入汉字、字母或数字，汉字算两个字符。
    </el-alert>
    <el-form label-width="100px" class="y-mt-20" :inline="false">
      <div class="view-content">
        <el-form-item label="用户名称">
          <el-input v-model="nickName" style="width: 250px" placeholder="请输入用户名称"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" plain>取 消</el-button>
      <el-button type="primary" @click="handleUpdate">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { updateUserNameApi } from '@/api/systemModule/accountSetting/info';
import { getStore } from '@/utils/localStorage';
export default {
  props: ['showUpdateNickNameDialog'],
  data() {
    return {
      visible: false,
      nickName: ''
    }
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:showUpdateNickNameDialog', false)
    },
    handleUpdate() {
      let reg = /^[\u4e00-\u9fa5a-zA-Z0-9]*$/; // 判断汉字、字母或数字
      let len = 0;
      // 一个汉字两个字符
      for (var i = 0; i < this.nickName.length; i++) {
        var a = this.nickName.charAt(i);
        if (a.match(/[^\x00-\xff]/ig) != null) {
          len += 2;
        } else {
          len += 1;
        }
      }
      if (!reg.test(this.nickName) || len > 16) {
        this.$message.error('名称长度1-16位字符，只可以输入汉字、字母或数字，汉字算两个字符。');
        return;
      }
      // 更新用户名称
      let params = {
        loginId: this.userMess.loginId,
        nickName: this.nickName
      }
      updateUserNameApi(params).then(res => {
        if(res.success) {
          this.$message.success('设置成功')
          // 更新数据
          this.$store.commit('SET_NICKNAME', this.nickName);
          let userInfo = JSON.parse(getStore('userInfo'));
          this.$store.dispatch('setUserInfo', {
            ...userInfo,
            nickName: this.nickName
          });
          this.$emit('update:showUpdateNickNameDialog', false)
        }
      })
    }
  },
  watch: {
    showUpdateNickNameDialog(val) {
      this.visible = val;
      this.nickName = this.userMess.nickName
    }
  }
}
</script>
